<rid-monosyllabic-keyboard
  class="h-dvh"
  [mode]="mode()"
  [prompts]="[
    {
      prompt: {
        type: 'AUDIO',
        size: 'SMALL',
        src: 'https://api.woordkr8.dev.gametailors.com/cas/schemas/woordkr8/data/woordkr8-dev/media/fetch/5aigNZYcGi_55uDArCUsW.mp3',
      },
      answer: ['k', 'a', 't'],
    },
    {
      prompt: {
        type: 'AUDIO',
        size: 'SMALL',
        src: 'https://api.woordkr8.dev.gametailors.com/cas/schemas/woordkr8/data/woordkr8-dev/media/fetch/JEOE5HvotZVLUtbnIaXb0.mp3',
      },
      answer: ['l', 'eeuw'],
    },
    {
      prompt: {
        type: 'AUDIO',
        size: 'SMALL',
        src: 'https://api.woordkr8.dev.gametailors.com/cas/schemas/woordkr8/data/woordkr8-dev/media/fetch/Wr-f443dvDruxd790zqqR.mp3',
      },
      answer: ['w', 'o', 'l', 'f'],
    },
  ]"
  (finished)="$router.navigate(['/mechanics/syllabic-keyboard'])"
/>
